export class AutoryzujEmailDoOswiadczenia {
  email: string;
  id: string;
}
